import { DateTime } from 'luxon'

export default date => {
  let diff = DateTime.local().diff(date).as('seconds')

  // Seconds
  if (diff < 60) {
    return {
      unit: 'seconds',
      diff: diff > 0 ? diff.toFixed(0) : 0
    }
  }

  // Minutes - 60*60
  if (diff < 3600) {
    return {
      unit: 'minutes',
      diff: (diff / 60).toFixed(0)
    }
  }

  // Hours - 60*60*24
  if (diff < 86400) {
    return {
      unit: 'hours',
      diff: (diff / 3600).toFixed(0)
    }
  }

  // Days - 60*60*24*30
  if (diff < 2592000) {
    return {
      unit: 'days',
      diff: (diff / 86400).toFixed(0)
    }
  }

  // Month - 60*60*24*365
  if (diff < 31536000) {
    return {
      unit: 'months',
      diff: (diff / 2592000).toFixed(0)
    }
  }

  // Year - 60*60*24*365
  return {
    unit: 'years',
    diff: (diff / 2592000).toFixed(0)
  }
}
